var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "#FCFCFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 8.75C7.41318 8.75 6.66699 9.49619 6.66699 10.4167C6.66699 11.3371 7.41318 12.0833 8.33366 12.0833H31.667C32.5875 12.0833 33.3337 11.3371 33.3337 10.4167C33.3337 9.49619 32.5875 8.75 31.667 8.75H8.33366Z",
    fill: "#0F1114"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 18.75C7.41318 18.75 6.66699 19.4962 6.66699 20.4167C6.66699 21.3371 7.41318 22.0833 8.33366 22.0833H31.667C32.5875 22.0833 33.3337 21.3371 33.3337 20.4167C33.3337 19.4962 32.5875 18.75 31.667 18.75H8.33366Z",
    fill: "#0F1114"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 29.1669C7.41318 29.1669 6.66699 29.9131 6.66699 30.8335C6.66699 31.754 7.41318 32.5002 8.33366 32.5002H31.667C32.5875 32.5002 33.3337 31.754 33.3337 30.8335C33.3337 29.9131 32.5875 29.1669 31.667 29.1669H8.33366Z",
    fill: "#0F1114"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger_menu.645da477.svg";
export { ForwardRef as ReactComponent };